// Reviews carousel functionality
document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.getElementById('reviews-carousel');
  const prevBtn = document.querySelector('.carousel-prev');
  const nextBtn = document.querySelector('.carousel-next');

  if (!carousel || !prevBtn || !nextBtn) return;

  const scrollAmount = 370; // Card width + gap

  prevBtn.addEventListener('click', function() {
    carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', function() {
    carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });

  // Update button states based on scroll position
  function updateButtons() {
    prevBtn.disabled = carousel.scrollLeft <= 0;
    nextBtn.disabled = carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth - 10;
  }

  carousel.addEventListener('scroll', updateButtons);
  window.addEventListener('resize', updateButtons);
  updateButtons();
});

// Team carousel functionality
document.addEventListener('DOMContentLoaded', function() {
  const teamCarousel = document.getElementById('team-carousel');
  const teamPrevBtn = document.querySelector('.team-carousel-prev');
  const teamNextBtn = document.querySelector('.team-carousel-next');

  if (!teamCarousel || !teamPrevBtn || !teamNextBtn) return;

  const scrollAmount = 370; // Card width + gap (matches reviews carousel)

  teamPrevBtn.addEventListener('click', function() {
    teamCarousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });

  teamNextBtn.addEventListener('click', function() {
    teamCarousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });

  // Update button states based on scroll position
  function updateTeamButtons() {
    teamPrevBtn.disabled = teamCarousel.scrollLeft <= 0;
    teamNextBtn.disabled = teamCarousel.scrollLeft >= teamCarousel.scrollWidth - teamCarousel.clientWidth - 10;
  }

  teamCarousel.addEventListener('scroll', updateTeamButtons);
  window.addEventListener('resize', updateTeamButtons);
  updateTeamButtons();
});

// Team bio "Read More" toggle functionality
document.addEventListener('DOMContentLoaded', function() {
  const bioToggles = document.querySelectorAll('.team-bio-toggle');

  bioToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      const bioText = this.previousElementSibling;
      const isExpanded = bioText.classList.toggle('expanded');
      this.classList.toggle('expanded', isExpanded);
      this.querySelector('span').textContent = isExpanded ? 'Read Less' : 'Read More';
    });
  });
});

// Relative time calculation
function getRelativeTime(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffYears > 0) {
    return diffYears === 1 ? '1 year ago' : `${diffYears} years ago`;
  } else if (diffMonths > 0) {
    return diffMonths === 1 ? '1 month ago' : `${diffMonths} months ago`;
  } else if (diffWeeks > 0) {
    return diffWeeks === 1 ? '1 week ago' : `${diffWeeks} weeks ago`;
  } else if (diffDays > 0) {
    return diffDays === 1 ? '1 day ago' : `${diffDays} days ago`;
  } else {
    return 'Today';
  }
}

// Export for use in build script
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { getRelativeTime };
}
